import _ from 'lodash';
import { wealthProApi } from '../../redux/api';

const valuationsApiEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ["valuation"]
})
    .injectEndpoints({
        endpoints: (builder) => ({
            fetchValuation: builder.query({
                query: ({ masterAccountId }) => ({
                    url: `api/valuations/${masterAccountId}`,
                    method: 'GET'
                }),
                providesTags: (result, error, arg) => {
                    return ['valuation'];
                }
            }),
            exportValuation: builder.query({
                query: (request) => ({
                    url: `api/valuations/pdf`,
                    method: 'POST',
                    body: request
                }),
            }),
            getAssetsSummary: builder.query({
                query: ({ userIds = [] }) => _.isEmpty(userIds)
                    ? `api/valuations/assetsSummary`
                    : `api/valuations/assetsSummary?userIds=${_.join(userIds, '&userIds=')}`
            })
        })
    });

export const {
    useFetchValuationQuery,
    useLazyExportValuationQuery,
    useGetAssetsSummaryQuery,
    useLazyGetAssetsSummaryQuery
} = valuationsApiEndpoints;